export const ERROR_TYPE_SIZE = 'size' as const;
export const ERROR_TYPE_EXTENSION = 'extension' as const;
export const ERROR_TYPE_DEFAULT = 'default' as const;
